import React from 'react';
import { useSelector } from 'react-redux';

export default function useGetItemEntryNo(hisId) {
  const [entryNo, setEntryNo] = React.useState(null);
  const cartInfo = useSelector((state) => state?.homecare?.hcCartInfo?.cartInfo);

  React.useEffect(() => {
    if (Object.keys(cartInfo).length > 0) {
      cartInfo?.items?.forEach((item) => {
        if (hisId === item?.productId) {
          setEntryNo(item?.entryNo);
        }
      });
    }
  }, [cartInfo]);

  return entryNo;
}
